import { alpha } from "@mui/material";
import { palette } from "../theme/palette";
const theme = palette("light");
export const getColorAndBackground = (status) => {
    switch (status) {
        case "Registered": //successful
            return {
                color: theme.success.dark,
                background: alpha(theme.success.dark, 0.16),
            };
        case "Invited":
            return {
                color: theme.primary.dark,
                background: alpha(theme.primary.dark, 0.16),
            };
        case "Pending":
            return {
                color: theme.common.white,
                background: "#9801B1",
            };
        case "Complete":
            return {
                color: theme.common.white,
                background: theme.success.main,
            };
        case "Declined":
            return {
                color: theme.error.dark,
                background: alpha(theme.error.dark, 0.16),
            };
        default:
            return { color: "#161C24", background: "#919EAB14" };
    }
};
export const convertModelToFormData = (data, form = new FormData(), namespace = "") => {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || !data[propertyName])
            continue;
        if (data[propertyName] instanceof Array) {
            if (data[propertyName].every((x) => x instanceof File)) {
                files[propertyName] = data[propertyName];
            }
            else {
                model[propertyName] = data[propertyName];
            }
        }
        else if (data[propertyName] instanceof File || data[propertyName]) {
            files[propertyName] = data[propertyName];
        }
        else {
            model[propertyName] = data[propertyName];
        }
    }
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date)
            formData.append(formKey, model[propertyName].toISOString());
        else if (model[propertyName] instanceof File) {
            formData.append(formKey, model[propertyName]);
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === "object")
                    convertModelToFormData(element, formData, tempFormKey);
                else
                    formData.append(tempFormKey, element.toString());
            });
        }
        else if (typeof model[propertyName] === "object" &&
            !(model[propertyName] instanceof File))
            convertModelToFormData(model[propertyName], formData, formKey);
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            if (files[propertyName] instanceof Array) {
                files[propertyName].forEach((element) => {
                    formData.append(propertyName, element);
                });
            }
            else
                formData.append(propertyName, files[propertyName]);
        }
    }
    return formData;
};
export const convertModelToFormDataForNestedFiles = (data, form = new FormData(), namespace = "") => {
    let files = {};
    let model = {};
    for (let propertyName in data) {
        if (!data.hasOwnProperty(propertyName) || !data[propertyName])
            continue;
        if (data[propertyName] instanceof Array) {
            if (data[propertyName].every((x) => x instanceof File)) {
                files[propertyName] = data[propertyName];
            }
            else {
                model[propertyName] = data[propertyName];
            }
        }
        else if (data[propertyName] instanceof File) {
            files[propertyName] = data[propertyName];
        }
        else {
            model[propertyName] = data[propertyName];
        }
    }
    let formData = form || new FormData();
    for (let propertyName in model) {
        if (!model.hasOwnProperty(propertyName) || !model[propertyName])
            continue;
        let formKey = namespace ? `${namespace}[${propertyName}]` : propertyName;
        if (model[propertyName] instanceof Date) {
            formData.append(formKey, model[propertyName].toISOString());
        }
        else if (model[propertyName] instanceof Array) {
            model[propertyName].forEach((element, index) => {
                const tempFormKey = `${formKey}[${index}]`;
                if (typeof element === "object") {
                    // Handle nested objects
                    convertModelToFormData(element, formData, tempFormKey);
                }
                else {
                    formData.append(tempFormKey, element.toString());
                }
            });
        }
        else if (typeof model[propertyName] === "object") {
            convertModelToFormData(model[propertyName], formData, formKey);
        }
        else {
            formData.append(formKey, model[propertyName].toString());
        }
    }
    for (let propertyName in files) {
        if (files.hasOwnProperty(propertyName)) {
            if (files[propertyName] instanceof Array) {
                files[propertyName].forEach((element) => {
                    formData.append(propertyName, element);
                });
            }
            else {
                formData.append(propertyName, files[propertyName]);
            }
        }
    }
    // Handle specific case for 'file nesting'
    if (data.otherDocuments && Array.isArray(data.otherDocuments)) {
        data.otherDocuments.forEach((doc, index) => {
            if (doc.fileData instanceof File) {
                formData.append(`otherDocuments[${index}].fileData`, doc.fileData);
            }
            // You can append other properties of doc as needed
            formData.append(`otherDocuments[${index}].type`, doc.type);
            formData.append(`otherDocuments[${index}].size`, doc.size);
        });
    }
    return formData;
};
export const formatPhoneNumber = (phone) => {
    // Remove any non-digit characters and +31 prefix if exists
    const cleaned = phone.replace(/\D/g, "").replace(/^31/, "");
    return cleaned ? `+31${cleaned}` : "";
};
export const displayPhoneNumber = (phone) => {
    // Remove any non-digit characters
    const cleaned = phone.replace(/\D/g, "");
    return cleaned.startsWith("31") ? cleaned.slice(2) : cleaned;
};
export const validateDate = (value) => {
    if (!value)
        return "validations.invalidDate";
    let date;
    if (value instanceof Date) {
        date = value;
    }
    else if (typeof value === "string") {
        date = new Date(value);
    }
    else {
        return "validations.invalidDate";
    }
    const isValid = !isNaN(date.getTime());
    return isValid || "validations.invalidDate";
};
export const validateIsFutureDate = (value) => {
    if (!value)
        return true;
    let date;
    if (value instanceof Date) {
        date = value;
    }
    else if (typeof value === "string") {
        date = new Date(value);
    }
    else {
        return true; // Let isValidDate handle this
    }
    if (isNaN(date.getTime()))
        return true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const input = new Date(date);
    input.setHours(0, 0, 0, 0);
    return input <= today || "validations.futureDateDisabled";
};
